import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de l'erreur 403.1
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-erreur4031',
  templateUrl: './erreur4031.component.html',
  styleUrls: ['./erreur4031.component.scss']
})
export class Erreur4031Component extends BaseComponent implements OnInit {

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
